import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  Input,
  TextArea,
  Form,
  Dropdown,
  Button,
  Table,
  Loader,
  Checkbox,
  Item,
  DropdownDivider,
} from 'semantic-ui-react';
import * as action from '../../../actions/newYouslim';
import { ImageVideoBlock } from '../CreateTraining/CreateTrainingStyles';
import Navbar from '../Navigation/Navbar';
import ChangeComplexStartDateModal from './ChangeComplexStartDateModal';
import EditIcon from '../../../images/edit_icon.png';
import {
  MarathonNameBlock,
  Label,
  CreateButton,
  ItemBlock,
  DateBlock,
  Content,
  Block,
  LinkBlock,
  ButtonBlock,
  SecondLinkBlock,
  H1,
  H2,
  FooterBlock,
  Buttons,
} from './MarathonStyles';
import { EditButton, Img } from '../CreateTrainingList/TrainingList';

import {
  defaultNormalUpTo65,
  defaultNormalFrom65To80,
  defaultNormalFrom80,
  defaultSimplifiedlUpTo65,
  defaultSimplifiedFrom65To80,
  defaultSimplifiedFrom80,
} from '../youslim2.0_Constants';
import { toastError } from '../../../utils/toastMessage';

const MarathonPage = ({
  getMarathonsList,
  marathonsList,
  getMarathonData,
  marathonData,
  getUserMenuMarathon,
  userMenuMarathon,
  createMarathon,
  updateMarathon,
}) => {
  const [isCreateMarathon, setIsCreateMarathon] = React.useState(false);
  const [isChangeComplexStartDate, setIsChangeComplexStartDate] = React.useState(false);
  const [complexDates, setComplexDates] = React.useState(undefined);
  const [startComplexDate, setStartComplexDate] = React.useState('');
  const [endComplexDate, setEndComplexDate] = React.useState('');
  const [newMarathonName, setNewMarathonName] = React.useState('');
  const [allMarathons, setAllMarathons] = React.useState([]);
  const [userMenu, setUserMenu] = React.useState([]);
  const [marathon, setMarathon] = React.useState([]);
  const [groupChatUrl, setGroupChatUrl] = React.useState('');
  const [marathonChannelUrl, setMarathonChannelUrl] = React.useState('');
  const [marathonId, setMarathonId] = React.useState(1);
  const [firstStartDate, setFirstStartDate] = React.useState('');
  const [secondStartDate, setSecondStartDate] = React.useState('');

  const [upTo65Normal, setUpTo65Normal] = React.useState(defaultNormalUpTo65);
  const [upTo65NormalId, setUpTo65NormalId] = React.useState(230);
  const [from65To80Normal, setFrom65To80Normal] = React.useState(defaultNormalFrom65To80);
  const [from65To80NormalId, setFrom65To80NormalId] = React.useState(231);
  const [from80Normal, setFrom80Normal] = React.useState(defaultNormalFrom80);
  const [from80NormalId, setFrom80NormalId] = React.useState(232);

  const [upTo65Simple, setUpTo65Simple] = React.useState(defaultSimplifiedlUpTo65);
  const [upTo65SimpleId, setUpTo65SimpleId] = React.useState(233);
  const [from65To80Simple, setFrom65To80Simple] = React.useState(defaultSimplifiedFrom65To80);
  const [from65To80SimpleId, setFrom65To80SimpleId] = React.useState(234);
  const [from80Simple, setFrom80Simple] = React.useState(defaultSimplifiedFrom80);
  const [from80SimpleId, setFrom80SimpleId] = React.useState(235);

  React.useEffect(() => {
    onClear();
  }, [isCreateMarathon]);

  React.useEffect(() => {
    getMarathonsList();
    getUserMenuMarathon();
  }, []);

  React.useEffect(() => {
    const listOfMarathons = [];
    marathonsList.map((item) => {
      listOfMarathons.push({
        id: item.id,
        name: item.name,
        value: item.name,
        text: item.name,
      });
    });
    setAllMarathons([...listOfMarathons]);
  }, [marathonsList]);

  React.useEffect(() => {
    const userMarathonMenu = [];
    userMenuMarathon.map((item) => {
      userMarathonMenu.push({
        id: item.id,
        name: item.name,
        value: item.name,
        text: item.name,
      });
    });
    setUserMenu([...userMarathonMenu]);
  }, [userMenuMarathon]);

  React.useEffect(() => {
    marathonData && marathonData.url_group_chat
      ? setGroupChatUrl(marathonData.url_group_chat)
      : setGroupChatUrl('');

    marathonData && marathonData.first_start_date
      ? setStartComplexDate(marathonData.first_start_date)
      : setStartComplexDate('');
    //   ? setFirstStartDate(marathonData.first_start_date)
    //   : setFirstStartDate('');
    marathonData && marathonData.second_start_date
      ? setSecondStartDate(marathonData.second_start_date)
      : setSecondStartDate('');
    marathonData && marathonData.url_marathon_channel
      ? setMarathonChannelUrl(marathonData.url_marathon_channel)
      : setMarathonChannelUrl('');
  }, [marathonData]);

  const selectMarathon = (data, id, index) => {
    setMarathon(data.value);
    const item = marathonsList.find((item) => item.name === data.value);
    setMarathonId(item.id);
    getMarathonData(item.id);
    getUserMenuMarathon();
  };

  React.useEffect(() => {
    if (complexDates) {
      const startDate = moment(complexDates[0]).format('YYYY-MM-DD');
      const endDate = moment(complexDates[1]).format('YYYY-MM-DD');

      //   const secDate = moment(startDate, 'DD-MM-YYYY').add(4, 'days');
      //   setSecondStartDate(secDate);
      setFirstStartDate(startDate);
      setStartComplexDate(startDate);
      setEndComplexDate(endDate);
    }
  }, [complexDates]);

  const onHandleDateChange = () => {
    setIsChangeComplexStartDate(true);
  };

  const onChangeTheDate = (value) => {
    setFirstStartDate(value);
    if (complexDates) {
      const startDate = moment(complexDates[0]).format('YYYY-MM-DD');
      //   moment(firstStartDate).add(7, 'days').format('YYYY-MM-DD')
      const secDate = moment(startDate).add(7, 'days').format('YYYY-MM-DD');
      setSecondStartDate(secDate);
    }
  };
  const onChangeComplexStartDate = (data) => {
    setIsChangeComplexStartDate(false);
  };

  const selectUpTo65Normal = (data) => {
    const user = userMenu.find((user) => user.name === data.value);
    setUpTo65NormalId(user.id);
    setUpTo65Normal(data.value);
  };

  const selectFrom65To80Normal = (data) => {
    const user = userMenu.find((user) => user.name === data.value);
    setFrom65To80NormalId(user.id);
    setFrom65To80Normal(data.value);
  };

  const selectFrom80Normal = (data) => {
    const user = userMenu.find((user) => user.name === data.value);
    setFrom80NormalId(user.id);
    setFrom80Normal(data.value);
  };
  const selectUpTo65Simple = (data) => {
    const user = userMenu.find((user) => user.name === data.value);
    setUpTo65Simple(data.value);
    setUpTo65SimpleId(user.id);
  };
  const selectFrom65To80Simple = (data) => {
    const user = userMenu.find((user) => user.name === data.value);
    setFrom65To80SimpleId(user.id);
    setFrom65To80Simple(data.value);
  };
  const selectFrom80Simple = (data) => {
    const user = userMenu.find((user) => user.name === data.value);
    setFrom80SimpleId(user.id);
    setFrom80Simple(data.value);
  };

  const onClear = React.useCallback(() => {
    setMarathon('');
    setNewMarathonName('');
    setMarathonChannelUrl(''), setFirstStartDate('');
    setSecondStartDate('');
    setGroupChatUrl('');
    setStartComplexDate('');
    setUpTo65Normal(defaultNormalUpTo65);
    setFrom65To80Normal(defaultNormalFrom65To80);
    setFrom80Normal(defaultNormalFrom80);
    setUpTo65Simple(defaultSimplifiedlUpTo65);
    setFrom65To80Simple(defaultSimplifiedFrom65To80);
    setFrom80Simple(defaultSimplifiedFrom80);
  }, [
    setMarathon,
    setNewMarathonName,
    setMarathonChannelUrl,
    setFirstStartDate,
    setStartComplexDate,
    setSecondStartDate,
    setGroupChatUrl,
    setUpTo65Normal,
    setFrom65To80Normal,
    setFrom80Normal,
    setUpTo65Simple,
    setFrom65To80Simple,
    setFrom80Simple,
  ]);

  const onSave = React.useCallback(() => {
    if (!newMarathonName && isCreateMarathon) {
      toastError('Название марафона не заполнено');
    }
    if (!marathonChannelUrl) {
      toastError('Ссылка на канал марафона не указана!');
    }
    if (!groupChatUrl) {
      toastError('Ссылка на групповой чат не указана!');
    }
    if (!firstStartDate) {
      toastError('Дата первого старта не указана!');
    }
    let currentUpTo65Normal = 0;
    userMenu.map((userUpTo65Normal) => {
      if (userUpTo65Normal.value === upTo65Normal) {
        currentUpTo65Normal = userUpTo65Normal.id;
      }
    });
    let currentFrom65To80Normal = 0;
    userMenu.map((userFrom65To80Normal) => {
      if (userFrom65To80Normal.value === from65To80Normal) {
        currentFrom65To80Normal = userFrom65To80Normal.id;
      }
    });

    let currentFrom80Normal = 0;
    userMenu.map((userFrom80Normal) => {
      if (userFrom80Normal.value === from80Normal) {
        currentFrom80Normal = userFrom80Normal.id;
      }
    });
    let currentUpTo65Simple = 0;
    userMenu.map((userUpTo65Simple) => {
      if (userUpTo65Simple.value === upTo65Simple) {
        currentUpTo65Simple = userUpTo65Simple.id;
      }
    });
    let currentFrom65To80Simple = 0;
    userMenu.map((userFrom65To80Simple) => {
      if (userFrom65To80Simple.value === from65To80Simple) {
        currentFrom65To80Simple = userFrom65To80Simple.id;
      }
    });
    let currentFrom80Simple = 0;
    userMenu.map((userFrom80Simple) => {
      if (userFrom80Simple.value === from80Simple) {
        currentFrom80Simple = userFrom80Simple.id;
      }
    });
    const secondDate = isCreateMarathon
      ? moment(firstStartDate).add(7, 'days').format('YYYY-MM-DD')
      : moment(startComplexDate).add(7, 'days').format('YYYY-MM-DD');
    const dataForRequest = {
      name: isCreateMarathon ? newMarathonName : marathon,
      first_start_date: isCreateMarathon ? startComplexDate : firstStartDate,
      second_start_date: secondDate,
      url_group_chat: groupChatUrl,
      url_marathon_channel: marathonChannelUrl,
      up_to_65_normal_user_id: currentUpTo65Normal,
      from_65_to_80_normal_user_id: currentFrom65To80Normal,
      from_80_normal_user_id: currentFrom80Normal,
      up_to_65_simplified_user_id: currentUpTo65Simple,
      from_65_to_80_simplified_user_id: currentFrom65To80Simple,
      from_80_simplified_user_id: currentFrom80Simple,
    };
    if (!isCreateMarathon) {
      updateMarathon(dataForRequest, marathonId);
    } else {
      createMarathon(dataForRequest);
    }
  });

  return (
    <React.Fragment>
      <Navbar />
      <Content>
        <MarathonNameBlock>
          {!isCreateMarathon && (
            <Dropdown
              openOnFocus
              fluid
              search
              selection
              options={allMarathons}
              placeholder="Выбор/Поиск по имени"
              value={marathon}
              onChange={(e, data) => selectMarathon(data)}
            />
          )}
          {isCreateMarathon && (
            <Input
              type="text"
              placeholder="Введите название нового марафона"
              maxLength="40"
              style={{ width: '100%' }}
              value={newMarathonName}
              onChange={(e) => setNewMarathonName(e.target.value)}
            />
          )}
          <CreateButton>
            <Button
              color="blue"
              onClick={() => {
                setIsCreateMarathon(!isCreateMarathon);
              }}
            >
              {!isCreateMarathon ? 'Создать новый марафон' : 'Назад к просмотру'}
            </Button>
          </CreateButton>
        </MarathonNameBlock>
        <Block>
          <DateBlock>
            <ItemBlock>
              <Label>Дата первого старта</Label>
              <Input
                // value={firstStartDate}
                value={isCreateMarathon ? firstStartDate : startComplexDate}
                // onChange={(event) => setStartComplexDate(event.target.value)}
                onChange={(event) => onChangeTheDate(event.target.value)}
              ></Input>
            </ItemBlock>
            <Button
              color="blue"
              onClick={onHandleDateChange}
              style={{ marginTop: '30px', width: '160px' }}
            >
              Выбрать дату
            </Button>
          </DateBlock>

          <DateBlock>
            <SecondLinkBlock>
              <Label>Ссылка на первый старт </Label>

              <Input style={{ width: '100%' }} disabled />
            </SecondLinkBlock>
          </DateBlock>
        </Block>

        <Block>
          <DateBlock>
            <ItemBlock>
              <Label>Дата второго старта</Label>
              <Input
                // value={secondStartDate}
                value={
                  isCreateMarathon
                    ? moment(firstStartDate).add(7, 'days').format('YYYY-MM-DD')
                    : moment(startComplexDate).add(7, 'days').format('YYYY-MM-DD')
                }
                onChange={(event) => onChangeTheDate(event.target.value)}
                disabled
              />
            </ItemBlock>
            <Button
              disabled
              color="blue"
              onClick={onHandleDateChange}
              style={{ marginTop: '30px', width: '160px' }}
            >
              Выбрать дату
            </Button>
          </DateBlock>
          <ButtonBlock>
            <Button style={{ backgroundColor: 'lightblue' }}>Сгенерировать ссылку</Button>
            <Button style={{ backgroundColor: 'lightgreen' }}>Скопировать ссылку </Button>
          </ButtonBlock>
        </Block>
        <Block>
          <DateBlock>
            <LinkBlock>
              <Label>Ссылка на Групповой чат Марафона</Label>
              <Input
                type="text"
                style={{ width: '100%' }}
                value={groupChatUrl}
                onChange={(event) => setGroupChatUrl(event.target.value)}
              />
            </LinkBlock>
          </DateBlock>
          <DateBlock>
            <SecondLinkBlock>
              <Label>Ссылка на второй старт </Label>
              <Input style={{ width: '100%' }} disabled />
            </SecondLinkBlock>
          </DateBlock>
        </Block>
        <Block>
          <DateBlock>
            <LinkBlock>
              <Label>Ссылка на канал Марафона</Label>
              <Input
                value={marathonChannelUrl}
                onChange={(event) => setMarathonChannelUrl(event.target.value)}
                style={{ width: '100%' }}
              />
            </LinkBlock>
          </DateBlock>
          <ButtonBlock>
            <Button style={{ backgroundColor: 'lightblue' }}>Сгенерировать ссылку </Button>
            <Button style={{ backgroundColor: 'lightgreen' }}>Скопировать ссылку </Button>
          </ButtonBlock>
        </Block>
        <Block>
          <DateBlock>
            <Label></Label>
          </DateBlock>
          <DateBlock>
            <LinkBlock>
              <Label>Количество клиентов в одной ссылке</Label>
              <Input type="number" min="0" defaultValue="2" disabled></Input>
            </LinkBlock>
          </DateBlock>
        </Block>
        <Block style={{ marginTop: '30px' }}>
          <ItemBlock>
            <H1>Полное меню</H1>
          </ItemBlock>
          <ItemBlock>
            <H1>Упрощённое меню </H1>
          </ItemBlock>
        </Block>

        <Block>
          <LinkBlock>
            <Label>Меню для клиентов до 65 кг </Label>
            <DateBlock style={{ width: '80%' }}>
              <Dropdown
                openOnFocus
                fluid
                search
                selection
                style={{ width: '100%' }}
                options={userMenu}
                value={upTo65Normal}
                onChange={(e, data) => selectUpTo65Normal(data)}
              />

              <EditButton target="_blank" to={`/youslim2.0/userPage/${upTo65NormalId}/change`}>
                <Img src={EditIcon} alt="edit" />
              </EditButton>
            </DateBlock>
          </LinkBlock>
          <DateBlock style={{ width: '90%' }}>
            <LinkBlock>
              <Label>Меню для клиентов до 65 кг</Label>
              <DateBlock style={{ width: '90%' }}>
                <Dropdown
                  openOnFocus
                  fluid
                  search
                  selection
                  style={{ width: '100%' }}
                  options={userMenu}
                  value={upTo65Simple}
                  onChange={(e, data) => selectUpTo65Simple(data)}
                />
                <EditButton target="_blank" to={`/youslim2.0/userPage/${upTo65SimpleId}/change`}>
                  <Img src={EditIcon} alt="edit" />
                </EditButton>
              </DateBlock>
            </LinkBlock>
          </DateBlock>
        </Block>
        <Block>
          <LinkBlock>
            <Label>Меню для клиентов от 65 кг до 80 кг </Label>
            <DateBlock style={{ width: '80%' }}>
              <Dropdown
                openOnFocus
                fluid
                search
                selection
                style={{ width: '100%' }}
                placeholder="Меню для клиентов от 65 кг до 80 кг"
                defaultValue={from65To80Normal}
                options={userMenu}
                onChange={(e, data) => selectFrom65To80Normal(data)}
              />
              <EditButton target="_blank" to={`/youslim2.0/userPage/${from65To80NormalId}/change`}>
                <Img src={EditIcon} alt="edit" />
              </EditButton>
            </DateBlock>
          </LinkBlock>
          <DateBlock style={{ width: '90%' }}>
            <LinkBlock>
              <Label>Меню для клиентов от 65 кг до 80 кг</Label>
              <DateBlock style={{ width: '90%' }}>
                <Dropdown
                  openOnFocus
                  fluid
                  search
                  selection
                  style={{ width: '100%' }}
                  placeholder="Меню для клиентов от 65 кг до 80 кг(упрощ)"
                  value={from65To80Simple}
                  options={userMenu}
                  onChange={(e, data) => selectFrom65To80Simple(data)}
                />
                <EditButton
                  target="_blank"
                  to={`/youslim2.0/userPage/${from65To80SimpleId}/change`}
                >
                  <Img src={EditIcon} alt="edit" />
                </EditButton>
              </DateBlock>
            </LinkBlock>
          </DateBlock>
        </Block>
        <Block>
          <LinkBlock>
            <Label>Меню для клиентов от 80 кг </Label>
            <DateBlock style={{ width: '80%' }}>
              <Dropdown
                openOnFocus
                fluid
                search
                selection
                style={{ width: '100%' }}
                placeholder="Меню для клиентов от 80 кг"
                value={from80Normal}
                options={userMenu}
                onChange={(e, data) => selectFrom80Normal(data)}
              />
              <EditButton target="_blank" to={`/youslim2.0/userPage/${from80NormalId}/change`}>
                <Img src={EditIcon} alt="edit" />
              </EditButton>
            </DateBlock>
          </LinkBlock>

          <LinkBlock>
            <Label>Меню для клиентов от 80 кг </Label>
            <DateBlock style={{ width: '80%' }}>
              <Dropdown
                openOnFocus
                fluid
                search
                selection
                style={{ width: '100%' }}
                placeholder="Меню для клиентов от 80 кг"
                value={from80Simple}
                options={userMenu}
                onChange={(e, data) => selectFrom80Simple(data)}
              />
              <EditButton target="_blank" to={`/youslim2.0/userPage/${from80SimpleId}/change`}>
                <Img src={EditIcon} alt="edit" />
              </EditButton>
            </DateBlock>
          </LinkBlock>
        </Block>

        <Buttons>
          <Button style={{ backgroundColor: 'lime' }} onClick={onSave}>
          {!isCreateMarathon? 'Обновить' : 'Сохранить'} 
          </Button>
          <Button style={{ backgroundColor: 'red' }} onClick={onClear}>
            Отмена
          </Button>
          <Button style={{ backgroundColor: 'lightblue' }} disabled>
            {/* disabled={isCreateMarathon} */}
            Клиенты
          </Button>
        </Buttons>
        <FooterBlock />
      </Content>
      <ChangeComplexStartDateModal
        isShow={isChangeComplexStartDate}
        onClose={setIsChangeComplexStartDate}
        changeComplexStartDate={onChangeComplexStartDate}
        complexDates={complexDates}
        setComplexDates={setComplexDates}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { marathonsList, marathonData, userMenuMarathon } = state.newYouslim;
  return { marathonsList, marathonData, userMenuMarathon };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getMarathonsList: () => {
      dispatch(action.getMarathonsList());
    },
    getMarathonData: (id) => {
      dispatch(action.getMarathonData(id));
    },
    getUserMenuMarathon: (name, id) => {
      dispatch(action.getUserMenuMarathon(name, id));
    },
    createMarathon: (data) => {
      dispatch(action.createMarathon(data));
    },
    updateMarathon: (data, id) => {
      dispatch(action.updateMarathon(data, id));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MarathonPage);



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/MarathonPage/index.jsx